const CHARS = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';

export function generateGameCode() {
  let code = '';
  for (let i = 0; i < 4; i++) {
    code += CHARS[Math.floor(Math.random() * CHARS.length)];
  }
  return code;
}
